import styled, { css } from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: ${props => props.width || '100%'};
  align-items: ${props => props.align || 'inherit'};
  margin-bottom: ${props => props.marginbottom || '6px'};
  justify-content: ${props => props.justify || 'inherit'};
  margin-left: ${props => props.marginleft || '0px'};
  margin-top: ${props => props.margintop || '0px'};
  ${props =>
    props.vertCenter &&
    css`
      align-items: center;
    `};
  @media (max-width: 800px) {
    flex-direction: ${props => props.flexDirection};
  }
`;

export default Row;
